import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  CompletedCircle,
  WarningTriangleFilled,
} from 'AppSrc/core/components/common/svg-icons';
import {
  currentSelectedNetwork,
  // isCrqEmergency,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import {
  getBackwardTransition,
} from 'AppSrc/core/crq/crq-status-transitions';
import {
  updateEditCrqWithId,
  updateRemedyRefCrqWithId,
} from 'AppSrc/core/actions/actions-update-edit-form';
import {
  clearEditSectionsRead,
  fetchRemedyRefCrqForError,
} from 'AppSrc/core/actions/actions-edit-form';
import { CRQ_TRANSITION_CONFIRMATION } from 'AppSrc/core/components/router/routes';
// import { CancelationReasonDropdown } from './modals/cancel-crq-modal';
import { VFDropdownBase } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown-base';
import {
  getCancelationReasonDisplayOptions,
} from 'AppSrc/core/crq/crq-status-reasons';
import { Loader } from 'AppSrc/core/components/utility/loader';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-actions.css';
import { PostponeCrqModal, PostponeAlertModal } from './modals/postpone-crq-model';
import { CancelCrqActionsModal } from './modals/cancel-crq-actions-modal';

const ViewCrqActionsDisplay = (
  {
    network,
    crqId,
    rejectToPrevStatus,
    postponeReason1,
    postponeReason2,
    postponeReason3,
    // for dealing view-crq-nav while performing crq-actions in approval stage.
    enableCancelApproval,
    enablePostponeApproval,
    errorAlert,
    status,
    riskValue,
    hasReferenceCRQ,
    remedyRefFormData,
    isEmergencyCrq,
  },
) => {

  const [enableSubmit, setEnableSubmit] = useState(false);
  const [postponeReason, setPostponeReason] = useState('');
  const [enablePostponeTickIcon, setEnablePostponeTickIcon] = useState(false);
  const [enableCancelTickIcon, setEnableCancelTickIcon] = useState(false);
  const [enablePostponeWarningIcon, setEnablePostponeWarningIcon] = useState(true);
  const [enableCancelWarningIcon, setEnableCancelWarningIcon] = useState(true);
  const [isCancelChecked, setIsCancelChecked] = useState(false);
  const [isPostponeChecked, setIsPostponeChecked] = useState(false);
  const [postponeModelOpen, setpostponeModelOpen] = useState(false);
  const [postponeAlertModalOpen, setPostponeAlertModalOpen] = useState(false);
  const [cancelCrqModelOpen, setcancelCrqModelOpen] = useState(false);
  const [ispostponeReason1] = useState((postponeReason1 && postponeReason1 !== '') ? true : false);
  const [ispostponeReason2] = useState((postponeReason2 && postponeReason2 !== '') ? true : false);
  const [ispostponeReason3] = useState((postponeReason3 && postponeReason3 !== '') ? true : false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const displayOptions = getCancelationReasonDisplayOptions(network);
  // const isEmergencyCrq = isCrqEmergency(formData);

  const mailId = 'ukchangemanagement@vodafone.com';

  const handleCancelCrq = () => {
    window.localStorage.setItem('crqActionIspostponeOrCancel', 'Cancel');
    setIsCancelChecked(true);
    setIsPostponeChecked(false);
    enableCancelApproval(true); // for dealing view-crq-nav while performing crq-actions in approval stage.
    enablePostponeApproval(false); // for dealing view-crq-nav while performing crq-actions in approval stage.
  };

  const handlePostponeCrq = () => {
    if (ispostponeReason1 && ispostponeReason2 && ispostponeReason3) {
      setPostponeAlertModalOpen(true);
    }
    else {
      window.localStorage.setItem('crqActionIspostponeOrCancel', 'Postpone');
      setIsPostponeChecked(true);
      setIsCancelChecked(false);
      enableCancelApproval(false); // for dealing view-crq-nav while performing crq-actions in approval stage.
      enablePostponeApproval(true); // for dealing view-crq-nav while performing crq-actions in approval stage.
    }
  };

  const handlePostponeReason = (e) => {
    setPostponeReason(e.target.value);
  };

  const onHandleNotification = () => {
    if (postponeReason.length > 14) {
      setEnableSubmit(true);
      setEnablePostponeWarningIcon(false);
      setEnablePostponeTickIcon(true);
      const subject = `Re:${crqId} Postpone comms needed`;
      const body = `Hi Change Management Team,%0D%0DThe following changes has been Postponed - ${crqId}.%0D%0DPlease could you send postponement is as follows: %0D${postponeReason}`;
      window.open(`mailto:${mailId}?subject=${subject}&body=${body}`);
    }
  };

  const onHandleCommunication = () => {
    if (selectedReason.length > 0) {
      setEnableSubmit(true);
      setEnableCancelWarningIcon(false);
      setEnableCancelTickIcon(true);
      const CancelReasonText = `${selectedReason}`;
      const subject = `Re:${crqId} Cancelled - comms needed`;
      const body = `Hi Change Management Team,%0D%0DThe following change has been Cancelled - ${crqId}.%0D%0DPlease could you send cancellation Comms with the cancellation reason as follows:%0D${CancelReasonText}`;
      window.open(`mailto:${mailId}?subject=${subject}&body=${body}`);
    }
  };

  const handleTickIcon = () => {
    if (selectedReason && selectedReason.length > 0) {
      setEnableSubmit(false);
      setEnableCancelTickIcon(false);
      setEnableCancelWarningIcon(true);
    }
  };

  const postponeCrqStatus = () => {
    setSubmitting(true);
    // changed the order of arguments, now sending hasReferenceCRQ in 4th for Vine crq actions functionalities.
    rejectToPrevStatus(network, postponeReason, true, hasReferenceCRQ, ispostponeReason1, ispostponeReason2, ispostponeReason3, remedyRefFormData)
      .then((response) => {
        setSubmitting(false);
      })
      .catch((error) => {
        console.error(error);
        errorAlert({
          errorTitle: 'Failed update CRQ',
          errorText: 'Sorry we are unable to update your CRQ due to a technical issue. Please try again later.',
        });
        setSubmitting(false);
      });
  };

  const cancelCrqStatus = () => {
    setSubmitting(true);
    rejectToPrevStatus(network, selectedReason, false, hasReferenceCRQ, remedyRefFormData)
      .then((response) => {
        setSubmitting(false);
      })
      .catch((error) => {
        console.error(error);
        errorAlert({
          errorTitle: 'Failed update CRQ',
          errorText: 'Sorry we are unable to update your CRQ due to a technical issue. Please try again later.',
        });
        setSubmitting(false);
      });
  };

  const handleSubmit = () => {
    if ((isPostponeChecked && enablePostponeTickIcon === true) || (isPostponeChecked && postponeReason.length > 14 && network === 'fixed') || (isPostponeChecked && postponeReason.length > 14 && network === 'mobile')) setpostponeModelOpen(true);
    if ((isCancelChecked && enableCancelTickIcon === true) || (isCancelChecked && selectedReason.length > 0 && network === 'fixed') || (isCancelChecked && selectedReason.length > 0 && network === 'mobile')) setcancelCrqModelOpen(true);
  };
  if (isSubmitting) {
    // set up a loader array that shows the loader at half loaded
    // TODO ideally this would be based on redux in terms of how many approvers have been saved
    const loaderArray = [true, false];
    return (
      <Loader
        loaderArray={loaderArray}
        loaderTitle="Please wait whilst we update your CRQ"
        loaderText="Do not close or refresh your browser whilst we do this."
      />
    );
  }
  return (
    <div>
      <div className="actions-container">
        <div className="title-container">
          <div>
            <span className="title">CRQ Actions</span>
          </div>
          <span className="info-text">Please note that comms will be automatically issued based on CRQ actions, If applicable.</span>
        </div>
        <div className="sub-contaner">
          <label htmlFor="cancelcrq" className="container">
            <input type="radio" id="cancelcrq" name="cancelcrq" value="cancelcrq" checked={isCancelChecked} onChange={handleCancelCrq} />
            <span className="checkmark" />
            <span className="radio-lbl">Cancel CRQ</span>
          </label>
          {isCancelChecked && (
            <div className="dropdown-conatiner">
              <div className="dropdown-info"> Please Provide reason for cancellation</div>
              <div className="dropdown-box" role="button" tabIndex="0" onClick={handleTickIcon} onKeyDown={handleTickIcon}>
                <VFDropdownBase
                  displayOptions={displayOptions}
                  updateValue={setSelectedReason}
                  name="cancelationReason"
                  value={selectedReason}
                  className="bgdropcolor"
                  placeholder="Please Select"
                />
              </div>
              {network === 'mobile' && selectedReason && status === '6' && (riskValue === 'Risk Level 3' || riskValue === 'Risk Level 4') && (
                <div className="notify-btn-container1">
                  <div>
                    <button
                      type="submit"
                      className="action-button notify-btn btn-active"
                      onClick={onHandleCommunication}
                    >
                      Notify Change Management
                    </button>
                  </div>
                  {(enableCancelWarningIcon && selectedReason.length > 0) && (
                    <div className="warning-container-svg-space-maker">
                      <div className="warning-container-svg">
                        <WarningTriangleFilled />
                      </div>
                    </div>
                  )}
                  {enableCancelTickIcon && (
                    <div className="svg-space-maker">
                      <div className="svg-tick-or-warning-container ">
                        <CompletedCircle />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {cancelCrqModelOpen && (
            <CancelCrqActionsModal
              closeModal={() => setcancelCrqModelOpen(false)}
              network={network}
              cancelCrqStatus={cancelCrqStatus}
              crqId={crqId}
            />
          )}
          {
            ((status === '7') || (status === 'Implementation In Progress') || isEmergencyCrq === true)
              ? null : (
                <label htmlFor="postpone" className="container">
                  <input type="radio" id="postpone" name="postpone" value="postpone" checked={isPostponeChecked} onChange={handlePostponeCrq} />
                  <span className="checkmark" />
                  <span className="radio-lbl">Postpone CRQ</span>
                </label>
              )
          }
        </div>
        {isPostponeChecked && (
          <div className="textarea-container">
            <textarea
              className="field-textarea"
              style={{ backgroundColor: 'white' }}
              type="textarea"
              placeholder="Please enter text"
              maxLength={200}
              value={postponeReason}
              onChange={handlePostponeReason}
            />
            <div className="comments-limit">
              Character Limit
              {' '}
              {postponeReason.length}
              /200
            </div>
            {network === 'mobile' && status === '6' && (riskValue === 'Risk Level 3' || riskValue === 'Risk Level 4') && (
              <div className="notify-btn-container">
                <div>
                  <button type="submit" className={`action-button notify-btn ${postponeReason.length > 14 ? 'btn-active' : 'btn-inActive'}`} onClick={onHandleNotification}>
                    Notify Change Management
                  </button>
                </div>
                {(enablePostponeWarningIcon && postponeReason.length > 14) && (
                  <div className="warning-container-svg-space-maker">
                    <div className="warning-container-svg">
                      <WarningTriangleFilled />
                    </div>
                  </div>
                )}
                {enablePostponeTickIcon && (
                  <div className="svg-space-maker">
                    <div className="svg-tick-or-warning-container ">
                      <CompletedCircle />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {postponeModelOpen && (
          <PostponeCrqModal
            closeModal={() => setpostponeModelOpen(false)}
            network={network}
            postponeCrqStatus={postponeCrqStatus}
            crqId={crqId}
          />
        )}
        {postponeAlertModalOpen && (
          <PostponeAlertModal
            closeModal={() => setPostponeAlertModalOpen(false)}
          />
        )}
      </div>
      <div className="form-nav-section">
        <div className="side-left" />
        <div className="side-right">
          <button
            type="submit"
            className={`action-button submit-btn
            ${((network === 'mobile' && enableSubmit) || (network === 'mobile' && (riskValue) && (isCancelChecked && (selectedReason ? selectedReason.length > 0 : 0) && (status === '5' || status === '4' || status === '6' || status === '7'))) || (network === 'mobile' && (riskValue) && (isPostponeChecked && postponeReason.length > 14 && (status === '5' || status === '4' || status === '6'))) || (isCancelChecked && (selectedReason ? selectedReason.length > 0 : 0) && network === 'fixed') || (isPostponeChecked && postponeReason.length > 14 && network === 'fixed')) ? 'btn-active' : 'btn-inActive'}`}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

ViewCrqActionsDisplay.propTypes = {
  network: PropTypes.string,
  crqId: PropTypes.string,
  status: PropTypes.string,
  // statusReason: PropTypes.string,
  rejectToPrevStatus: PropTypes.func,
  postponeReason1: PropTypes.string,
  postponeReason2: PropTypes.string,
  postponeReason3: PropTypes.string,
  enableCancelApproval: PropTypes.func,
  enablePostponeApproval: PropTypes.func,
  errorAlert: PropTypes.func,
  riskValue: PropTypes.string,
  hasReferenceCRQ: PropTypes.func,
  remedyRefFormData: PropTypes.objectOf(PropTypes.string),
  isEmergencyCrq: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const { crqId } = ownProps;
  const formData = state.editForm.formDataById[crqId];
  const network = formData ? currentSelectedNetwork(formData) : null;
  return { network };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  errorAlert: (alertData) => {
    dispatch(setErrorAlert(alertData));
  },
  // changed the order of arguments, now sending hasReferenceCRQ in 4th for Vine crq actions functionalities.
  rejectToPrevStatus: (network, selectedReason, isPostponeReson, hasReferenceCRQ, ispostponeReason1, ispostponeReason2, ispostponeReason3, remedyRefFormData) => {
    const {
      crqId,
      isShowCrqAction,
    } = ownProps;
    let postponeStatus = '12';
    let postponeStatusReason = '2000';
    // const mobilePostponeStatus = '12';
    let mobilePostponeStatusReason = 'To Be Re-Scheduled';

    const statusTransition = getBackwardTransition({ currentStatus: ownProps.status, isShowCrqAction, crqActionIspostponeOrCancel: window.localStorage.getItem('crqActionIspostponeOrCancel') });
    return dispatch(updateEditCrqWithId(crqId, statusTransition, selectedReason, isPostponeReson, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason))
      .then(() => {
        if (isPostponeReson && network === 'fixed') {
          postponeStatus = '3';
          postponeStatusReason = '30300';
          dispatch(updateEditCrqWithId(crqId, statusTransition, selectedReason, isPostponeReson, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason))
            .then(() => {
              dispatch(clearEditSectionsRead(crqId));
              if (hasReferenceCRQ() === true && (remedyRefFormData.status === 'Scheduled For Review' || remedyRefFormData.status === 'Scheduled For Approval' || remedyRefFormData.status === 'Scheduled')) {
                const isRefPostponeReason1 = true;
                // const remedyRefStatus = 'Planning In Progress';
                // const remedyRefStatusReason = 'PostponedCRQ';
                const remedyRefStatus1 = 'Cancelled';
                const remedyRefStatusReason1 = 'To Be Re-Scheduled';
                // const postponeAdjReason1 = 'Your adjacent Fixed Crq has been postponed';
                dispatch(updateRemedyRefCrqWithId(crqId, remedyRefStatus1, remedyRefStatusReason1, isRefPostponeReason1))
                  .then(() => {
                    const isRefPostponeReason = true;
                    const remedyRefStatus = 'Planning In Progress';
                    const remedyRefStatusReason = 'PostponedCRQ';
                    // const postponeAdjReason1 = 'Your adjacent Fixed Crq has been postponed';
                    dispatch(updateRemedyRefCrqWithId(crqId, remedyRefStatus, remedyRefStatusReason, isRefPostponeReason))
                      .catch((error) => {
                        console.error(error);
                        fetchRemedyRefCrqForError(error);
                        return Promise.reject(error);
                      });
                  });
              }
              // navigate to the success route, with the correct crqId
              const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                network,
                crqId,
                transitionId: statusTransition.id,
              });
              ownProps.history.push(successPath);
              return true;
            })
            .catch((error) => {
              console.error(error);
              // TODO add error alert
            });
        }
        else if (isPostponeReson && network === 'mobile') {
          postponeStatus = '3';
          mobilePostponeStatusReason = 'PostponedCRQ';
          dispatch(updateEditCrqWithId(crqId, statusTransition, selectedReason, isPostponeReson, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason))
            .then(() => {
              dispatch(clearEditSectionsRead(crqId));
              // navigate to the success route, with the correct crqId
              const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                network,
                crqId,
                transitionId: statusTransition.id,
              });
              ownProps.history.push(successPath);
            })
            .catch((error) => {
              console.error(error);
              // TODO add error alert
            });
        }
        else {
          dispatch(clearEditSectionsRead(crqId));
          if (hasReferenceCRQ() === true) {
            // const isRefPostponeReason = true;
            console.log('iscoming');
            const remedyRefStatus = 'Cancelled';
            const remedyRefStatusReason = 'No Longer Required';
            // const postponeAdjReason1 = 'Your adjacent Fixed Crq has been postponed';
            dispatch(updateRemedyRefCrqWithId(crqId, remedyRefStatus, remedyRefStatusReason))
              .catch((error) => {
                console.error(error);
                fetchRemedyRefCrqForError(error);
                return Promise.reject(error);
              });
          }
          // navigate to the success route, with the correct crqId
          const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
            network,
            crqId,
            transitionId: statusTransition.id,
          });
          ownProps.history.push(successPath);
        }
      })
      .catch((error) => {
        console.error(error);
        // TODO add error alert
      });
  },
});

const ViewCrqActions = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewCrqActionsDisplay));



export { ViewCrqActions };
